// import './App.css';
import { Route, Routes, useLocation } from "react-router-dom";

import ErrorPageComp from "./CommanCom/ErrorPageComp";
import UserRoutes from "./PrivateRoutes/UserRoutes";
import LoginComp from "./AppCom/Login/LoginComp";
import DashboardComp from "./AppCom/Dashboard/DashboardComp";
import PolicyCom from "./AppCom/HR/PolicyCom";
import UserAttendanceCom from "./AppCom/Attendance/UserAttendanceCom";
import NewUserAttendance from "./AppCom/Attendance/Attandence_list";
import EmployeeListCom from "./AppCom/Employee/EmployeeListCom";
import AddEmployeeCom from "./AppCom/Employee/AddEmployeeCom";
import EditEmployeeCom from "./AppCom/Employee/EditEmployeeCom";
import ApprovetimesheetCom from './AppCom/ApproveTimesheet/ApprovetimesheetCom';
import ProfileCom from "./AppCom/Employee/ProfileCom";
import ResetPassSendLink from './AppCom/BulkEmail/ResetPassSendLink'
import NewPasswordCom from "./AppCom/Login/NewPasswordCom";
import ItCom from "./AppCom/IT/ItCom";
import UpdateItInfoComp from "./AppCom/IT/UpdateItInfoComp"
import HrRoutes from "./PrivateRoutes/HrRoutes";
import FeedNewsCom from "./AppCom/HR/FeedNewsCom";
import HolidayListCom from "./AppCom/HR/HolidayListCom";
import EmpLeaveCom from "./AppCom/Employee/EmpLeaveCom";
import MomentsQbsComp from "./AppCom/HR/MomentsQbsComp";
import QuoteCom from "./AppCom/HR/QuoteCom";
import './index.scss'
// import EmpAttendanceCom from "./AppCom/HR/EmpAttendanceCom";
// import LeaveApprovalComp from "./AppCom/HR/Approval/LeaveApprovalComp";
import AttendanceApprovalComp from "./AppCom/HR/Approval/AttendanceApprovalComp";
import LeaveApprovalComp from "./AppCom/HR/Approval/LeaveApprovalComp";

import QbsconnectTalkComp from './AppCom/HR/QbsconnectTalkComp'
import UserDirectoryComp from "./AppCom/Employee/UserDirectoryComp";
import LocationComp from "./AppCom/HR/LocationComp";

import PermissionCom from "./AppCom/HR/PermissionCom";

import Skills from "./AppCom/HR/Skills/Skills";
import OnboardingList from "./AppCom/HR/onboarding/onboardingList";
import NewJoiningFrom from "./AppCom/HR/onboarding/JoiningFrom";
import EmailVerification from "./AppCom/HR/onboarding/EmailVerification";
import ReportAttendanceCom from "./AppCom/HR/Reports/ReportAttendanceCom";
import JoiningSuccessPage from './AppCom/HR/onboarding/JoiningSuccessPage';
import ViewJoiningForm from "./AppCom/HR/onboarding/ViewJoiningForm";
import UserMenuComp from "./AppCom/HR/Menus/UserMenuComp";
import ItRoute from "./PrivateRoutes/ItRoute";
import UpdateUserProfileCom from "./AppCom/Employee/UpdateUserProfileCom";
import UserReportsComp from "./AppCom/HR/Reports/UserReportsComp";
import SystemActivity from "./CommanCom/SystemActivity";
import UserLoginReports from "./AppCom/HR/Reports/UserLoginReportsComp"

function App() {

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LoginComp />} />
        <Route path="/login" element={<LoginComp />} />
        <Route path="/check-logs" element={<SystemActivity />} />
        <Route path="/new-joining" element={<NewJoiningFrom />} />
        <Route path="/email-verify" element={<EmailVerification />} />
        <Route path="/joining-success" element={<JoiningSuccessPage />} />
        <Route path="/viewjoiningform" element={<HrRoutes header_title='DASHBOARD' menu_id='6' ><ViewJoiningForm /></HrRoutes>} />
        <Route path="/dashboard" element={<UserRoutes header_title='DASHBOARD'><DashboardComp /></UserRoutes>} />
        <Route path="/attendance2" element={<UserRoutes header_title='DASHBOARD'><NewUserAttendance /></UserRoutes>} />
        <Route path="/attendance" element={<UserRoutes header_title='DASHBOARD'><UserAttendanceCom /></UserRoutes>} />
        <Route path="/user-directry" element={<UserRoutes header_title='DASHBOARD'><UserDirectoryComp /></UserRoutes>} />



        <Route path="/approvetimesheet" element={<UserRoutes header_title='DASHBOARD'><ApprovetimesheetCom /></UserRoutes>} />
        <Route path="/profile" element={<UserRoutes header_title='DASHBOARD'><ProfileCom /></UserRoutes>} />
        <Route path="/updateprofile" element={<UserRoutes header_title='DASHBOARD'><UpdateUserProfileCom /></UserRoutes>} />

        <Route path="/new-password" element={<NewPasswordCom />} />

        <Route path="/updateemail" exact={true} element={<ItRoute header_title='DASHBOARD' menu_id='6'><ItCom /></ItRoute>} />
        <Route path="/updateinfo/:id" exact={true} element={<ItRoute header_title='DASHBOARD' menu_id='6'><UpdateItInfoComp /></ItRoute>} />

        <Route path="/systeminformation" exact={true} element={<UserRoutes header_title='DASHBOARD'><ItCom /></UserRoutes>} />

        <Route path="/leave" element={<UserRoutes header_title='DASHBOARD'><EmpLeaveCom /></UserRoutes>} />

        <Route path="/policy" element={<HrRoutes header_title='DASHBOARD' menu_id='6'><PolicyCom /></HrRoutes>} />
        <Route path="/skills" element={<HrRoutes header_title='DASHBOARD' menu_id='7'><Skills /></HrRoutes>} />
        <Route path="/onboarding" element={<HrRoutes header_title='DASHBOARD' menu_id='31'><OnboardingList /></HrRoutes>} />
        <Route path="/employeelist" element={<HrRoutes header_title='DASHBOARD' menu_id='8'><EmployeeListCom /></HrRoutes>} />
        <Route path="/addemployee" element={<HrRoutes header_title='DASHBOARD' menu_id='26'><AddEmployeeCom /></HrRoutes>} />
        <Route path="/editemployee" exact={true} element={<HrRoutes header_title='DASHBOARD' menu_id='27'><EditEmployeeCom /></HrRoutes>} />

        <Route path="/emp-attendance-approval-list" element={<HrRoutes header_title='DASHBOARD' menu_id='9'><AttendanceApprovalComp /></HrRoutes>} />
        <Route path="/emp-leave-approval-list" element={<HrRoutes header_title='DASHBOARD' menu_id='9'><LeaveApprovalComp /></HrRoutes>} />

        <Route path="/resetpassword" element={<HrRoutes header_title='DASHBOARD' menu_id='10'><ResetPassSendLink /></HrRoutes>} />
        <Route path="/feed-news" element={<HrRoutes header_title='DASHBOARD' menu_id='11'><FeedNewsCom /></HrRoutes>} />
        <Route path="/momentsqbs" element={<HrRoutes header_title='DASHBOARD' menu_id='12'><MomentsQbsComp /></HrRoutes>} />
        <Route path="/quotelist" element={<HrRoutes header_title='DASHBOARD' menu_id='13'><QuoteCom /></HrRoutes>} />
        <Route path="/holidaylist" element={<HrRoutes header_title='DASHBOARD' menu_id='14'><HolidayListCom /></HrRoutes>} />
        <Route path="/qbsconnecttalklist" element={<HrRoutes header_title='DASHBOARD' menu_id='15'><QbsconnectTalkComp /></HrRoutes>} />
        <Route path="/location" element={<HrRoutes header_title='Location' menu_id='16'><LocationComp /></HrRoutes>} />
        <Route path="/permission" element={<HrRoutes header_title='Permission' menu_id='17'><PermissionCom /></HrRoutes>} />
        <Route path="/reports" element={<HrRoutes header_title='Permission' menu_id='17'><ReportAttendanceCom /></HrRoutes>} />

        <Route path="/usermenu" element={<HrRoutes header_title='Menu' menu_id='88'><UserMenuComp /></HrRoutes>} />
        <Route path="/userreports" element={<HrRoutes header_title='Menu' menu_id='88'><UserReportsComp /></HrRoutes>} />
        <Route path="/userloginreports" element={<HrRoutes header_title='Menu' menu_id='88'><UserLoginReports /></HrRoutes>} />
        <Route path='*' exact={true} element={<ErrorPageComp />} />

        {/* updateinfo */}
      </Routes>

    </div>
  );
}

export default App;
